
const num = Math.floor(Math.random() * ((35+1) - 0) + 0);
const Aletaoria  = () => {
    return ( 
        num
     );
}
 
export default Aletaoria ;